import { useQuery } from '@tanstack/react-query';
import { getFormTemplateOptions } from '@drivingdoc/api-client/generated/react-query';

import PdfViewer from './components/PdfViewer';

interface PreviewProps {
  formId: string;
}

export function Preview({ formId }: PreviewProps) {
  // fetch the form
  const form = useQuery({
    ...getFormTemplateOptions({
      path: {
        id: formId ?? '',
      },
    }),
    enabled: !!formId,
  });
  const formData = form.data as { link?: string } | undefined;

  return <>{formData?.link && <PdfViewer fileUrl={formData?.link} />}</>;
}

export default Preview;
